import { render, staticRenderFns } from "./video-animation-h5.vue?vue&type=template&id=1fd1b496&scoped=true&"
import script from "./video-animation-h5.vue?vue&type=script&lang=js&"
export * from "./video-animation-h5.vue?vue&type=script&lang=js&"
import style0 from "./video-animation-h5.vue?vue&type=style&index=0&id=1fd1b496&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd1b496",
  null
  
)

export default component.exports